import { Flashcard, FlashcardType } from '../types/Flashcard';

export const MULTI_BLANK_TOKEN = '[[blank]]';

export const countMultiBlankTokens = (question: string): number => {
  if (!question) {
    return 0;
  }

  const matches = question.match(/\[\[blank\]\]/g);
  return matches ? matches.length : 0;
};

export const splitMultiBlankQuestion = (question: string): string[] => {
  return question.split(MULTI_BLANK_TOKEN);
};

export const buildMultiBlankPreview = (question: string): string => {
  let blankNumber = 0;

  return question.replace(/\[\[blank\]\]/g, () => {
    blankNumber += 1;
    return `[Blank ${blankNumber}]`;
  });
};

export const getFlashcardTypeLabel = (card: Pick<Flashcard, 'type' | 'correctChoiceIndices'>): string => {
  switch (card.type) {
    case FlashcardType.TrueFalse:
      return 'True/False';
    case FlashcardType.MultipleChoice:
      return (card.correctChoiceIndices?.length || 0) > 1 ? 'Multiple Select' : 'Multiple Choice';
    case FlashcardType.Ordering:
      return 'Ordering';
    case FlashcardType.MultiBlankChoice:
      return 'Multi-Blank Choice';
    case FlashcardType.Matching:
      return 'Matching';
    case FlashcardType.QuestionAnswer:
    default:
      return 'Question & Answer';
  }
};

export const getFlashcardQuestionPreview = (card: Pick<Flashcard, 'type' | 'question'>): string => {
  if (card.type === FlashcardType.MultiBlankChoice) {
    return buildMultiBlankPreview(card.question);
  }

  return card.question;
};